var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"recommended-people-ctrl",attrs:{"to":{name: 'recommended-people'},"data-tip":"people-recommendations"}},[_c('div',{staticClass:"recommended-people-ctrl__title"},[_vm._v(_vm._s(_vm.locale("title")))])])}
var staticRenderFns = []

export { render, staticRenderFns }